import api from '@/utils/api';

/**
 * Get all companies
 * @param {string} query - Query to filter companies
 * @returns {Promise}
 */
const getCompaniesApi = (query) => {
  const url = query ? `company?${query}` : 'company';
  return api.get(url);
};

export default getCompaniesApi;
